export function stringSort<T extends Record<string, unknown>>(property: keyof T & string) {
  return (a: T, b: T): number => {
    const valA = a[property]
    const valB = b[property]
    const stringA = typeof valA === 'string' ? valA.toUpperCase() : ''
    const stringB = typeof valB === 'string' ? valB.toUpperCase() : ''
    let comparison = 0

    if (stringA > stringB) {
      comparison = 1
    } else if (stringA < stringB) {
      comparison = -1
    }
    return comparison
  }
}
